<template>
  <v-container fluid fill-height ma-0 pa-0 >
    <v-layout fill-height pa-0>
      <v-flex xs12 pa-0>
        <v-layout column fill-height justify-start ma-0 pa-0 >
          <v-flex style="position: relative" pa-0>
            <v-layout column v-if="!editeble" fill-height pa-0 class="white">

              <scroll-table
                :data="getTable"
                :options="getOptions"
                :device="getSelected"
                :hideState="['off']"
                :rowclick="false"
                :rowStatus="true"
                :addButton="true"
                @chart="(payload)=>{$emit('chart', payload)}"
                @value="(row, item)=>{$emit('value', row, item)}"
                @unplug="(payload)=>unplugMeasurement(payload)"
                @addForeign="()=>onAddForeignMeasure()"
                @showRules="row => setRulesAndOpen(row)"
              />

            </v-layout>

            <v-layout v-if="editeble" column fill-height pa-0 class="white">
              <v-layout class="primary" py-1 px-2>
                <v-toolbar-title class="primary subtitle-2 back--text text-uppercase" >
                  <span class="body-2 text-uppercase"> {{ $t('disabling individual options from polling') }} </span>
                </v-toolbar-title>

                <v-layout fill-height justify-end align-center>
                  <v-tooltip dark color="secondary" bottom>
                    <v-btn v-if="haveToUpdateMeasures" small flat  color="white" slot="activator" light text 
                    :data-testid="$options.name + '__btn__' + 'updateMeasures'"
                    @click="() => updateMeasures()">{{$t('save changes')}}</v-btn>
                    <span class="white--text">{{ $t('save changes') }}</span>
                  </v-tooltip>
                </v-layout>
              </v-layout>

              <scroll-area>
                <template slot="body">
                  <v-layout v-for="(m, index) in getMeasures" :key="'params_links_' + index"  align-end class="params_links" ma-0>
                    <v-flex xs3 pa-1 pb-1 align-self-end>
                      <span class="black--text">{{m.name}}</span>
                    </v-flex>

                    <v-flex grow pb-1 pr-1 align-self-end>
                      <span class="uppercase body-2 primary--text">{{$t('disable')}}:</span>
                    </v-flex>

                    <v-flex xs8 pb-1>
                      <v-layout fill-height ma-0>
                        <v-flex xs4 pb-1>
                          <v-checkbox
                            :data-testid="$options.name + '__checkbox__' + 'params_links_' + index"
                            v-model="m.options.noState"
                            light
                            small
                            hide-details
                            color="secondary"
                            @change="() => checkboxUpdated(m)"
                          >
                            <template v-slot:label>
                              <span class="black--text">{{$t('apply to status')}}</span>
                            </template>
                          </v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </template>
              </scroll-area>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-dialog v-model="dialog.addForeign.open" max-width="50%" v-if="dialog.addForeign.open">
        <add-foreign-card
          :data="getDevices"
          @plugMeasurement="(payload) => plugMeasurement(payload)"
          @close="() => closeAddForeignMeasure()"
        />
      </v-dialog>

    </v-layout>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import addForeignCard from '@/nms/pages/equipment/add-foreign-card.vue'

// Типы
interface MeasureOption {
  [key: string]: boolean
}

interface MeasureItem {
  $id?: string
  $ref_id?: string
  name?: string
  message?: string
  value?: any
  unit?: string
  options?: MeasureOption
  mirror?: {
    value?: any
    type?: string
  }
  index?: number
  hidden?: string
  noStore?: boolean
  noState?: boolean
  noConnection?: boolean
  [key: string]: any
}

interface TableColumn {
  title: string
  value: string | null
  type: string
  width: string
  cursor?: string
  actions?: Array<{
    title: string
    tooltip: string
    icon: string
    color: string
    size: string
    emit: string
  }>
}

interface TableData {
  columns: TableColumn[]
  rows: MeasureItem[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface DialogState {
  addForeign: { open: boolean }
}

interface EquipmentData {
  $id?: string
  [key: string]: any
}

interface MetaField {
  name?: string
  descriptor?: Record<string, any>
  [key: string]: any
}

interface MetaData {
  fields?: MetaField[]
  [key: string]: any
}

interface CmdbQueryResponse {
  refs?: Array<{ cls?: string; ref?: string; id?: string }>
  [key: string]: any
}

interface SubscribeMeasureData {
  [key: string]: MeasureItem
}

export default Vue.extend({
  name: 'EQUIPMENT_TABLE',

  components: {
    scrollTable,
    scrollArea,
    addForeignCard,
  },

  props: {
    data: {
      type: Object as () => EquipmentData,
      default: () => ({})
    },
    devices: {
      type: Array as () => any[],
      default: () => []
    },
    editeble: {
      type: Boolean,
      default: () => false
    },
    updater: {
      type: Number,
      default: () => 0
    },
  },

  data(): {
    measureObj: EquipmentData
    measures: MeasureItem[]
    measuresStatuses: Record<string, MeasureItem>
    selected: string | null
    measuresForChange: MeasureItem[]
    haveToUpdateMeasures: boolean
    dialog: DialogState
    options: OptionsData
    filter: any | null
    search: string
    table: TableData
  } {
    return {
      measureObj: {},
      measures: [],
      measuresStatuses: {},
      selected: null,
      measuresForChange: [],
      haveToUpdateMeasures: false,
      dialog: {
        addForeign: { open: false }
      },
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      filter: null,
      search: '',
      table: {
        columns: [
          {
            title: 'name',
            value: 'name',
            type: 'text',
            width: '50%'
          },
          {
            title: 'last update',
            value: 'rt',
            type: 'timestamp',
            width: '20%'
          },
          {
            title: 'value',
            value: 'message',
            type: 'text',
            cursor: 'pointer',
            width: '20%',
          },
          {
            title: 'chart',
            value: null,
            type: 'actions',
            cursor: 'pointer',
            width: '5%',
            actions: [
              {
                title: 'chart',
                tooltip: 'chart',
                icon: 'dashboards',
                color: 'green',
                size: '22',
                emit: 'chart'
              },
            ],
          }
        ],
        rows: []
      }
    }
  },

  computed: {
    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData

      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },

    getOptions(): OptionsData {
      return this.options
    },

    getSelected(): EquipmentData {
      return this.data
    },

    getDevices(): any[] {
      return this.devices
    },

    getMeasures(): MeasureItem[] {
      return this.measures.filter(row => row.hidden !== 'true')
    },
  },

  watch: {
    data: {
      handler(newVal: EquipmentData): void {
        if (this.measureObj.$id !== newVal.$id) {
          this.measureObj = newVal
          this.setup('WATCH DATA')
        }
      },
      deep: true
    },
    '$store.state.subscribe.measure': {
      handler(newVal: Record<string, SubscribeMeasureData>): void {
        const selectedId = this.getSelected.$id
        if (selectedId && newVal[selectedId] && Object.keys(newVal[selectedId]).length) {
          this.setLoader('$store.state.subscribe.measure', true)
          this.measures = []
          Object.keys(newVal[selectedId]).forEach(key => {
            const measure = newVal[selectedId][key]
            measure.options = measure.options || {}
            this.measures.push(measure)
          })
          this.setLoader('$store.state.subscribe.measure', false)
        }
      },
      deep: true
    },
    measures: {
      handler(newVal: MeasureItem[], oldVal: MeasureItem[]): void {
        if (newVal.length === oldVal.length && newVal.length > 0) {
          this.haveToUpdateMeasures = true
        }
        this.setLoader('$store.state.subscribe.measure', true)
        this.deviceUnsubscribe('WATCH measure')
        this.prepareRows('WATCH measure')
        this.setLoader('$store.state.subscribe.measure', false)
      },
      deep: true
    },
    updater: {
      handler(newVal: number): void {
        console.log('WATCH', this.$options.name, 'updater', 'newVal', newVal)
        if (newVal) {
          this.setup('WATCH UPDATER')
          this.updateMeasures()
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup('created')
  },

  beforeDestroy(): void {
    this.deviceUnsubscribe('BEFOREDESTROYED')
  },

  methods: {
    setup(caller: string): void {
      if (this.getSelected) {
        this.loadMeasures()
      }
    },

    async loadMeasures(): Promise<void> {
      this.measures = []
      this.measuresStatuses = {}

      const meta = await this.$bridge.getMeta('measure') as MetaData
      const optionsField = meta.fields?.find((field: MetaField) => field.name === 'options')
      const options: MeasureOption = {}

      if (optionsField?.descriptor) {
        Object.keys(optionsField.descriptor).forEach(key => {
          options[key] = false
        })
      }

      this.setLoader('loadMeasures', true)

      const objId = this.selected || this.data.$id
      const obj$ = await this.$bridge.getObjectById(objId)
      const measures = await obj$.getMeasures(true, false) as MeasureItem[]

      if (measures) {
        // console.log(this.$options.name, 'loadMeasures', 'FIRST_MEASURES', JSON.parse(JSON.stringify(measures)))
        try {
          this.measures = measures.map((measure, i) => {
            if (!measure.options || Array.isArray(measure.options)) {
              measure.options = this.$merge({}, options)
              measure.index = i
              this.$set(this.measuresStatuses, measure.$id || '', measure)
            } else if (Object.keys(measure.options).length < 1) {
              measure.options = this.$merge({}, options)
              measure.index = i
              this.$set(this.measuresStatuses, measure.$id || '', measure)
            }
            return measure
          })
        } catch (err) {
          console.error(this.$options.name, 'loadMeasures', 'error', err)
        }
      }

      console.log(this.$options.name, 'loadMeasures', 'this.measuresStatuses', this.measuresStatuses)
      this.setLoader('loadMeasures', false)
    },

    async updateMeasures(): Promise<void> {
      try {
        this.setLoader('updateMeasures', true)

        for (const measure of this.measuresForChange) {
          const obj$ = await this.$bridge.getObjectById(measure.$id)
          await obj$.update({ options: measure.options })
        }

        const device = await this.$bridge.getObjectById(this.getSelected.$id)
        if (device) {
          await device.initPolling()
        }

        this.setLoader('updateMeasures', false)
        const message = this.$getTranslate('changes successfully saved')
        this.$dialog.notify.success(message, { timeout: 5000 })
      } catch (err) {
        this.setLoader('updateMeasures', false)
        this.$errorHandler(err)
      }
    },

    prepareRows(caller: string): void {
      this.setLoader('prepareRows', true)
      this.reset()

      console.log(this.$options.name, 'prepareRows', caller, 'measures', this.measures)

      this.measures.forEach((measure, index) => {
        const obj$ = this.$merge({}, { ...measure, ...measure.mirror }) as MeasureItem
        obj$.noStore = true
        obj$.noState = true
        obj$.noConnection = true

        if (Object.keys(measure.options || {}).length) {
          Object.keys(measure.options || {}).forEach(key => {
            obj$[key] = !measure.options![key]
          })
        }

        if (!obj$.message && obj$.value) {
          obj$.message = obj$.value
        }

        if (obj$.message && measure.unit) {
          if (typeof obj$.message === 'number') {
            obj$.message = obj$.message.toFixed(2) + ' ' + measure.unit
          } else {
            obj$.message = obj$.message + ' ' + measure.unit
          }
        }

        this.table.rows.push(obj$)
      })

      this.setLoader('prepareRows', false)
      console.log(this.$options.name, 'prepareRows', 'rows', this.table.rows)
      this.deviceSubscribe('prepareRows')
    },

    async deviceSubscribe(caller: string): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        handler: this.subscribeHandler,
        group: this.$options.name,
        listener: 'data'
      })

      if (this.measures.length) {
        await this.$bridge.subscribe(this.measures.map(el => el.$id))
      }
    },

    subscribeHandler(e: MeasureItem): void {
      if (this.measuresStatuses[e.$id || '']) {
        const n = { ...this.table.rows[this.measuresStatuses[e.$id || ''].index || 0], ...e }
        if(e.$id == 'measure$121702') {
          console.log('measure$121702', e)
        }
        
        if (e.message && e.message.length) {
          n.message = e.message
        }
        else if(e.value) {
          n.message = e.value
        }

        if(n.unit) {
          n.message = n.message + ' ' + n.unit
        }

        this.$set(this.table.rows, this.measuresStatuses[e.$id || ''].index || 0, n)
      }
    },

    deviceUnsubscribe(caller: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: this.$options.name,
        listener: 'data'
      })
    },

    onAddForeignMeasure(): void {
      console.log(this.$options.name, 'onAddForeignMeasure')
      this.$set(this.dialog.addForeign, 'open', true)
    },

    closeAddForeignMeasure(): void {
      this.$set(this.dialog.addForeign, 'open', false)
    },

    async plugMeasurement(val: { id: string }): Promise<void> {
      console.log(this.$options.name, 'plugMeasurement', 'Measurement', val)
      console.log(this.$options.name, 'plugMeasurement', 'updated_obj', this.getSelected)

      try {
        const query = {
          id: [this.getSelected.$id],
          notNull: true,
          data: { refs: true }
        }
        const obj = await this.$bridge.cmdbQuery(query) as CmdbQueryResponse[]

        const refs = obj[0]?.refs || []
        refs.push({ cls: 'measure', ref: 'measure', id: val.id })

        const u = await obj[0]?.update({ refs })
        console.log(this.$options.name, 'plugMeasurement', 'update', u)
        this.loadMeasures()
      } catch (error) {
        console.error('CATCH', this.$options.name, 'plugMeasurement', 'SMTH WRONG', error)
      }
    },

    async unplugMeasurement(val: { $ref_id?: string }): Promise<void> {
      console.log(this.$options.name, 'unplugMeasurement', 'Measurement', val)
      console.log(this.$options.name, 'unplugMeasurement', 'getSelected', this.getSelected)

      try {
        const obj$ = await this.$bridge.getObjectById(this.getSelected.$id)
        await obj$.deleteRefs([val.$ref_id])
      } catch (error) {
        console.error('CATCH', this.$options.name, 'unplugMeasurement', 'SMTH WRONG', error)
      }
    },

    reset(): void {
      this.$set(this.table, 'rows', [])
    },

    checkboxUpdated(val: MeasureItem, pay?: any): void {
      if (!this.measuresForChange.some(measure => measure.$id === val.$id)) {
        this.measuresForChange.push(val)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },
  },
})
</script>

<style>
</style>
